/**
 * Normalise a user-pasted video URL into something embeddable.
 * Returns { kind: 'iframe' | 'video', src } or null.
 *
 *   YouTube (watch / youtu.be / shorts / embed) → youtube.com/embed/ID
 *   Vimeo                                        → player.vimeo.com/video/ID
 *   Direct .mp4/.webm/.ogg                       → <video> source
 *   Anything else                                → treated as an iframe src
 */
export function videoEmbed(url) {
  if (!url || typeof url !== 'string') return null;
  const u = url.trim();
  if (!u) return null;

  let m = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (m) return { kind: 'iframe', src: `https://www.youtube.com/embed/${m[1]}` };

  m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return { kind: 'iframe', src: `https://player.vimeo.com/video/${m[1]}` };

  if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(u)) return { kind: 'video', src: u };

  return { kind: 'iframe', src: u };
}
